import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import { useConnectorAccount } from './useConnectorAccount';
import '../Profile.css';

// Informational instructions only. Staff verifies payments before changing balances.
export default function TalentConnectorRechargePage() {
  const { t, i18n } = useTranslation('profile');
  const { currentUser } = useAuth();
  const { data } = useConnectorAccount(currentUser);
  const balance = data?.balance;
  const mode = balance?.mode;
  const owing = mode === 'postpaid' && balance.amount_due_cents > 0;
  const title = owing ? 'payAmountDue' : mode === 'prepaid' ? 'addPrepaidFunds' : mode === 'trial' ? 'enablePaidUsage' : 'rechargeTitle';
  const hint = owing ? 'rechargeHintPostpaid' : mode === 'prepaid' ? 'rechargeHintPrepaid' : mode === 'trial' ? 'rechargeHintTrial' : mode === 'postpaid' ? 'rechargeHintNoDue' : 'rechargeHint';
  const money = cents => new Intl.NumberFormat(i18n.language, { style: 'currency', currency: 'USD' }).format((cents || 0) / 100);
  const subject = owing ? 'Talent Search payment' : mode === 'prepaid' ? 'Talent Search prepaid funds' : 'Talent Search account help';
  return <main className="profile-page-container connector-approval-page" dir={i18n.dir()}>
    <Link to="/profile?tab=usage" className="settings-back-link"><i className="fa-solid fa-arrow-left" aria-hidden="true" /> {t('connector.viewUsage')}</Link>
    <section className="profile-panel connector-approval-card connector-recharge-card">
      <span className="connector-approval-icon" aria-hidden="true"><i className="fa-solid fa-wallet" /></span>
      <h1>{t(`connector.${title}`)}</h1>
      <p>{t('connector.rechargeInstructions')}</p>
      <a href={`mailto:hassan@jobseeqr.co?subject=${encodeURIComponent(subject)}`} dir="ltr">hassan@jobseeqr.co</a>
      <p className="profile-muted-copy">{t(`connector.${hint}`, { amount: money(balance?.amount_due_cents), limit: money(balance?.unpaid_limit_cents) })}</p>
    </section>
  </main>;
}
